import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Modal, { ModalHeader, ModalBody, ModalFooter } from "./Modal";

export default function ConfirmDialog({
  title,
  message,
  confirmLabel,
  confirmClassName = "btn btn-success",
  cancelLabel,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();

  return (
    <Modal>
      <ModalHeader>
        <h5 className="modal-title">{title}</h5>
      </ModalHeader>
      <ModalBody>
        <p>{message}</p>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-default" onClick={onCancel}>
          {cancelLabel || t("common.cancel")}
        </button>
        <button type="button" className={confirmClassName} onClick={onConfirm}>
          {confirmLabel || t("common.confirm")}
        </button>
      </ModalFooter>
    </Modal>
  );
}

ConfirmDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  confirmClassName: PropTypes.string,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
